import { render } from "./PageOne.vue?vue&type=template&id=25caf117&scoped=true"
import script from "./PageOne.vue?vue&type=script&lang=js"
export * from "./PageOne.vue?vue&type=script&lang=js"

import "./PageOne.vue?vue&type=style&index=0&id=25caf117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25caf117"]])

export default __exports__